import { Navigate } from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import SessionReload from "./component-assets/SessionReload.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import TasksEhr from "./TasksEhr.jsx";
import TestComponent from "./TestComponent.jsx";
import TasksMaint from "./TasksMaint.jsx";

const Tasks = (props) => {
    let tasksContent, dData, paramVars, bData;
    paramVars = useParams();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    if (paramVars.dType === "ehr" && (compareRole("caregiver", dData?.userrole) || iAmHigherAuthority(10, dData.role_weight))){
        tasksContent = <TasksEhr />;
        // tasksContent = <TestComponent />
    }else if (paramVars.dType === "maintenance"){
        if (dData?.campusData[dData.acnt.toString()]?.is_cloud){
            tasksContent = <TasksMaint />
        }else{
            return <Navigate to={"/"} />
        }
    }else{
        tasksContent = (
            <div>
                <h3>Page not found. 404</h3>
            </div>
        );
    }

    return (dData.campusData[dData.acnt.toString()]?.ehr_active || iAmHigherAuthority(10, dData.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {tasksContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Tasks;